import RouteLoader from "./RouteLoader";
export default RouteLoader;



// WEBPACK FOOTER //
// ./src/services/route-loader/index.js